/**
 * GetFormattedDate
 *
 * Returns the formatted date for a given date.
 * If no date is provided, it uses the current one
 *
 * @return {function}
 */

OT.createNS('OT.Search.Helpers.getFormattedDate');

OT.Search.Helpers.getFormattedDate = function(date) {

    var d = date === undefined ? moment() : moment(date);
    return d.format(Resources.Strings.DateFormat.toUpperCase());

};
